import classes from './RoadEngineering.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Link} from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const RoadEngineering = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = t('roadEngineering.title')
    const description = t('roadEngineering.text', {returnObjects: true})

    const blackBlocks = t('roadEngineering.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('roadEngineering.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('roadEngineering.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('roadEngineering.benefitBlocks', {returnObjects: true})

    const stories = t('roadEngineering.stories', {returnObjects: true})



    const useCaseText = t('roadEngineering.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('roadEngineering.Faq.left', {returnObjects: true}),
        right: t('roadEngineering.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    Road Engineering IT Solutions 🏗️ Smart Infrastructure & IoT
                </title>
                <meta
                    name="description"
                    content="Improve road engineering with smart infrastructure solutions! 🚦 GIS mapping, IoT monitoring & AI-driven maintenance. Explore innovations today! 🏢"
                />
                <link rel="canonical" href="https://go-te.co/industries/road-engineering" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={770}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('roadEngineering.blackBlocksTitle')}</h3>
                        <p>{t('roadEngineering.blackBlocksText')}</p>
                        <p>{t('roadEngineering.blackBlocksText2')}
                        </p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('roadEngineering.challengesBlocksTitle')}</h2>
                        <p>{t('roadEngineering.challengesBlocksText')}</p>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('roadEngineering.solutionsBlocksTitle')}</h2>
                        <p>{t('roadEngineering.solutionsBlocksText')}</p>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div className={classes.block} key={title}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('roadEngineering.benefitBlocksTitle')}</h2>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('roadEngineering.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('roadEngineering.useCase')}</h2>
                            <div className={classes.text}>
                                <img src={eRoadImg} alt="Road engineering use case"/>
                                <p>{useCaseText}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('roadEngineering.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('roadEngineering.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img className={classes.img} src={eRoadImg} alt="Road engineering system"/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard
                        title={t('roadEngineering.formCard.title')}
                        message={t('roadEngineering.formCard.message')}
                        buttonText={t('roadEngineering.formCard.buttonText')}
                        labels={t('roadEngineering.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
                </section>

                <section className="section--light-gray" id="nav-dark">
                    <FrequentlyAskedQuestions title={t('roadEngineering.Faq.title')} questions={questions}/>
                </section>
            </main>
        </>
    );
};

export default RoadEngineering;